export enum IconType {
    WARNING,
    SEVERE_WARNING,
    ERROR,
    SUCESS,
    INFO,
    NONE,
};

export enum ButtonsType {
    CANCEL_RETRY_CONTINUE,
    OK,
    OK_CANCEL,
    RETRY_CANCEL,
    YES_NO,
    YES_NO_CANCEL,
    CUSTOM,
};

export enum DialogResult {
    ABORT,
    RETRY,
    IGNORE,
    CANCEL,
    OK,
    CONTINUE,
    YES,
    NO,
    CUSTOM,
};

export enum NotificationType {
    SUCCESS,
    ERROR,
    WARNING,
    INFO
};

export enum NotificationPosition {
	TOP_RIGHT,
    TOP_CENTER,
    TOP_LEFT,
    BOTTOM_RIGHT,
    BOTTOM_CENTER,
    BOTTOM_LEFT,
};